<template>
  <div v-if="data" class="d-flex align-center">
    <!-- chip -->
    <div class="d-flex align-center justify-center"
      style="background-color: #EFF0F6; padding: 0px 10px 0px 6px"
      :style="{width: chipWidth, height: chipHeight, borderRadius: `calc(${chipHeight} / 2)`}"
    >
      <!-- File, Workflow, Re:D -->
      <div v-if="data?.category" class="d-flex align-center">
        <!-- File -->
        <div v-if="data?.category === 'file' && data?.file" class="d-flex align-center">
          <!-- Excel -->
          <div v-if="data?.file.includes('xls') || data?.file.includes('csv')" class="d-flex align-center">
            <img src="/assets/data_icon/icon_excel.svg" :style="{width: iconWidth, height: iconHeight}">
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
              Excel
            </div>
          </div>
          <!-- Image -->
          <div v-else-if="data?.file.includes('jpg') || data?.file.includes('jpeg') || data?.file.includes('png')" class="d-flex align-center">
            <img src="/assets/data_icon/icon_img.svg" :style="{width: iconWidth, height: iconHeight}">
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
              Image
            </div>
          </div>
          <!-- PDF -->
          <div v-else-if="data?.file.includes('pdf')" class="d-flex align-center">
            <img src="/assets/data_icon/icon_pdf2.svg" :style="{width: iconWidth, height: iconHeight}">
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
              PDF
            </div>
          </div>
          <!-- Json -->
          <div v-else-if="data?.file.includes('json')" class="d-flex align-center">
            <img src="/assets/data_icon/icon_json2.svg" :style="{width: iconWidth, height: iconHeight}">
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
              Json
            </div>
          </div>
          <!-- Etc -->
          <div v-else class="d-flex align-center">
            <img src="/assets/data_icon/icon_unknown.svg" :style="{width: iconWidth, height: iconHeight}">
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
              Etc
            </div>
          </div>
        </div>
        <!-- master -->
        <div v-else-if="data?.category === 'master'" class="d-flex align-center">
          <img src="/assets/data_icon/icon_master.svg" :style="{width: iconWidth, height: iconHeight}">
          <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
            Table
          </div>
        </div>
        <!-- Workflow -->
        <div v-else-if="data?.category === 'rpa'" class="d-flex align-center">
          <img src="/assets/data_icon/icon_rpa2.svg" :style="{width: iconWidth, height: iconHeight}">
          <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
            Workflow
          </div>
        </div>
        <!-- Re:D -->
        <div v-else class="d-flex align-center">
          <img src="/assets/data_icon/icon_recolumn2.svg" :style="{width: iconWidth, height: iconHeight}">
          <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
            Re:D
          </div>
        </div>
      </div>
      <!-- Workflow (result_file) -->
      <div v-else-if="data?.data_type === 'result_file'" class="d-flex align-center">
        <img src="/assets/data_icon/icon_rpa2.svg" :style="{width: iconWidth, height: iconHeight}">
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
          Workflow
        </div>
      </div>
      <!-- Re:D -->
      <div v-else class="d-flex align-center">
        <img src="/assets/data_icon/icon_recolumn2.svg" :style="{width: iconWidth, height: iconHeight}">
        <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #414458; margin-left: 2px">
          Re:D
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataChip",

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    chipWidth: {
      type: String,
      default: 'auto'
    },
    chipHeight: {
      type: String,
      default: '24px'
    },
    iconWidth: {
      type: String,
      default: '20px'
    },
    iconHeight: {
      type: String,
      default: '20px'
    },
  },

  mounted() {
    // console.log('DataChip mounted')
    // console.log('data', this.data)
  }
}
</script>

<style scoped>
* {
  font-family: "Noto Sans KR";
}
</style>